export const getAnalyticsContext = () => {
  return {
    userAgent: window.navigator.userAgent,
    page: {
      url: window.location.href,
    },
  };
};
